import type { StepKind } from '@sb/routine-runner';

import { type ValidationRule } from '../../types';
import { ActionRequiredError } from '../../util/errors';

import { CanonicalStepRuleBase } from './base';
import type { CanonicalValidateArgs } from './base';

class LoopControlRule extends CanonicalStepRuleBase {
  public constructor() {
    super('steps.LoopControl', 'LoopControl');
  }

  protected validate({ parents }: CanonicalValidateArgs): void {
    this.checkHasLoopParent(parents);
  }

  /**
   * Check if the step has a Loop parent.
   * @param parents - The parents of the step.
   * @returns True if the step has a Loop parent, false otherwise.
   */
  private checkHasLoopParent(
    parents: Array<{ stepKind: StepKind | string }>,
  ): void {
    const ok = parents.some((p) => p?.stepKind === 'Loop');

    if (!ok) {
      throw new ActionRequiredError({
        kind: 'invalidConfiguration',
        message: 'Move Restart Loop inside a Loop step',
      });
    }
  }
}

export const LoopControlValidation: ValidationRule =
  new LoopControlRule().toValidationRule();
